import {
  Button,
  PHONE_COUNTRIES,
  PhoneInput,
  type Country,
} from "@/components";
import { PublicRoutes } from "@/constants/routes";
import { useRequestOtp } from "@/domain/auth";
import { useToast } from "@/hooks";
import { useOtpLoginPrefillStore } from "@/store/otpLoginPrefillStore";
import { phoneUtils } from "@/utils";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router";

export const OtpLoginPhone = () => {
  // Lê o prefill vindo da tela de Auth (estado em memória, nunca persistido
  // em localStorage/cookies) uma única vez, sem efeito colateral no render.
  const prefillRef = useRef(useOtpLoginPrefillStore.getState());

  const [country, setCountry] = useState<Country>(
    prefillRef.current.country ?? PHONE_COUNTRIES[0]
  );
  const [phone, setPhone] = useState(prefillRef.current.phone);

  useEffect(() => {
    useOtpLoginPrefillStore.getState().clearPrefill();
  }, []);

  const { requestOtp, isRequestingOtp } = useRequestOtp();
  const navigate = useNavigate();
  const { showToast } = useToast();

  // Brasil aceita fixo (10) ou celular (11); demais países usam só `length`.
  const minPhoneLength = country.minLength ?? country.length;
  const isPhoneComplete =
    phone.length >= minPhoneLength && phone.length <= country.length;

  const handleCountryChange = (next: Country) => {
    setCountry(next);
    setPhone(prev => prev.slice(0, next.length));
  };

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const national = phoneUtils.cleanPhoneNumber(phone);
    // Brasil mantém o número nacional; demais países enviam DDI + número.
    const cellPhone =
      country.code === "BR" ? national : `${country.ddi}${national}`;

    requestOtp(
      { cellPhone },
      {
        onSuccess: () => {
          navigate(`${PublicRoutes.AUTH_OTP_CODE}?phone=${cellPhone}`);
        },
        onError: error => showToast(error.message, "error"),
      }
    );
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold text-black">
          Entrar com WhatsApp
        </h1>
        <p className="text-base text-gray-500">
          Enviaremos um código de 6 dígitos para o seu WhatsApp.
        </p>
      </div>

      <form onSubmit={onSubmit} className="flex flex-col gap-5">
        <PhoneInput
          label="Celular"
          autoFocus
          country={country}
          onCountryChange={handleCountryChange}
          value={phone}
          onChange={setPhone}
        />

        <Button
          type="submit"
          isLoading={isRequestingOtp}
          disabled={!isPhoneComplete}
        >
          Receber código via WhatsApp
        </Button>
      </form>

      <p className="text-center text-sm text-gray-500">
        Prefere usar senha?{" "}
        <Link
          to={PublicRoutes.AUTH}
          className="cursor-pointer font-medium text-primary hover:underline"
        >
          Entrar com senha
        </Link>
      </p>
    </div>
  );
};
